<template>
  <section class="s-products">
    <div class="s-products__conts">
      <!-- <div class="s-breadcrumb-target"></div> -->
      <div class="s-products__conts__header">
        <div class="s-products__conts__header__left">
          <div class="s-breadcrumb-target"></div>
          <h1 class="s-products__title">{{ dictionary.title }}</h1>

          <Loader v-if="isLoading" display="absolute"></Loader>
          <Toggle
            v-if="toggleData"
            :data="toggleData"
            class="mb-64"
            @change-toggle="onChangeToggle"></Toggle>

          <ProductsFilters
            v-if="!errorMsgs.length"
            :filters-data="filtersData"
            :pre-selected-filters="preSelectedFilters"
            @on-change-filter="onChangeFilter">
            <slot></slot>
          </ProductsFilters>
        </div>
        <div class="s-products__conts__header__right">
          <img v-if="heroImage" :src="heroImage.url" :alt="heroImage.alt" />
        </div>
      </div>

      <div class="s-products__conts__main">
        <ProductsTable
          v-if="!errorMsgs.length && toggleType && records"
          :records="records" />

        <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

        <div class="s-products__btn">
          <a
            v-if="!errorMsgs.length"
            :href="showMoreUrl"
            class="btn btn--block btn-icon-outline-blue">
            <span>{{ dictionary.buttonLabel }}</span>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'
import ProductsTable from '../components/ProductsTable.vue'
import ProductsFilters from '../components/ProductsFilters.vue'
import Toggle from '../components/Toggle.vue'
import { v4 as uuidv4 } from 'uuid'

import * as lib from '../../lib/lib'

export default {
  components: {
    Loader,
    Alert,
    ProductsTable,
    ProductsFilters,
    Toggle,
  },

  data() {
    return {
      // default
      isLoading: false,
      errorMsgs: [],
      records: [],
    //  headers: [],
      title: '',
      filtersData: [],
      toggleType: true,
      toggleData: null,
      selectedFilters: [],
      selectedToggle: [],

      preSelectedFilters: [],
      preSelectedToggle: '',

      category: '',
      riskProfile: '',
      heroImage: null,
      showMoreUrl: '#',
    }
  },

  mounted() {
    const { title, toggleData, filtersData, heroImage, showMoreUrl } =
      lib.getData('productsData')
    this.title = title
    this.toggleData = toggleData
    this.filtersData = filtersData
    this.heroImage = heroImage
    this.selectedToggle = toggleData.filter((item) => item.isSelected)[0].id

    if (showMoreUrl) this.showMoreUrl = showMoreUrl

    if (lib.getUrlParam('category')) {
      this.preSelectedFilters.push({
        id: filtersData[0].id,
        selectedFilterId: lib.getUrlParam('category'),
      })
    }
    if (lib.getUrlParam('riskProfile')) {
      this.preSelectedFilters.push({
        id: filtersData[1].id,
        selectedFilterId: lib.getUrlParam('riskProfile'),
      })
    }
    if (lib.getUrlParam('shareClassCategory')) {
      this.preSelectedToggle = lib.getUrlParam('shareClassCategory')
    }

    this.$nextTick(() => {
      this.setPreselected()
      this.fetchData()
    })
  },

  methods: {
    getUrlParams() {
      // console.log(lib.getUrlParam('category'))
      if (lib.getUrlParam('category')) {
        this.category = lib.getUrlParam('category')
      } else {
        this.category = ''
      }

      if (lib.getUrlParam('riskProfile')) {
        this.riskProfile = lib.getUrlParam('riskProfile')
      } else {
        this.riskProfile = ''
      }

      if (lib.getUrlParam('shareClassCategory')) {
        this.selectedToggle = lib.getUrlParam('shareClassCategory')
      }
    },
    setUrlParams() {
      let category = ''
      let riskProfile = ''

      if (this.selectedFilters[0]) {
        if (this.selectedFilters[0].id === this.filtersData[0].id) {
          category = this.selectedFilters[0].value.id
        } else if (this.selectedFilters[0].id === this.filtersData[1].id) {
          riskProfile = this.selectedFilters[0].value.id
        }
      }

      if (this.selectedFilters[1]) {
        if (this.selectedFilters[1].id === this.filtersData[0].id) {
          category = this.selectedFilters[1].value.id
        } else if (this.selectedFilters[1].id === this.filtersData[1].id) {
          riskProfile = this.selectedFilters[1].value.id
        }
      }

      lib.appendUrlParams(
        ['category', 'riskProfile', 'shareClassCategory'],
        [category, riskProfile, this.selectedToggle]
      )
    },
    setPreselected() {
      if (this.preSelectedToggle) {
        if (this.preSelectedToggle === this.selectedToggle) {
          // console.log("preselected toggle didn't run")
          return false
        }
        const newData = this.toggleData.map((item) => ({
          ...item,
          isSelected: false,
        }))
        const finalData = newData.map((item) => {
          if (item.id === this.preSelectedToggle) {
            return {
              ...item,
              isSelected: true,
            }
          }
          return {
            ...item,
          }
        })
        this.toggleData = null
        this.$nextTick(() => {
          this.toggleData = finalData
        })
      }
    },

    onChangeToggle(data) {
      if (this.selectedToggle !== data) {
        this.selectedToggle = data
        this.setUrlParams()
        this.fetchData()
      }
    },
    onChangeFilter(data) {
      this.selectedFilters = data
      this.setUrlParams()
      this.fetchData()
    },
    generateId() {
      return uuidv4()
    },
    toggleSwitch() {
      this.toggleType = !this.toggleType
    },  

    fetchData() {
      this.isLoading = true

      this.getUrlParams()

      const postData = {
        category: this.category,
        riskProfile: this.riskProfile,
        shareClassCategory: this.selectedToggle      
      }

      axios
        .post(this.configuration.dataHandler, postData)
        .then((response) => {
          const { hasError, errorMessages, data } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }

          const { records } = data
          this.records = records

          lib.scrollToElem(jQuery('.s-products'), 100)

          this.$nextTick(() => {
            this.handleSuccess()
          })
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },
  },
}
</script>
